export function normalizeRequestedCurrency(value: string | null | undefined): string | null {
  const normalized = value?.trim().toUpperCase();
  return normalized && /^[A-Z]{3}$/.test(normalized) ? normalized : null;
}

/**
 * The buyer currency every priced SDK call uses (ADR-0066): an explicit
 * `?currency=` on the page wins, then the currency from `init()`. One rule for
 * catalog reads, cart quotes and checkout, so they can never disagree.
 */
export function resolveBuyerCurrency(configCurrency: string | null | undefined): string | null {
  return getRequestedCurrencyFromLocation() ?? normalizeRequestedCurrency(configCurrency);
}

export function getRequestedCurrencyFromLocation(): string | null {
  if (typeof window === 'undefined' || !window.location) {
    return null;
  }

  const search = typeof window.location.search === 'string' ? window.location.search : '';
  if (search) {
    return normalizeRequestedCurrency(new URLSearchParams(search).get('currency'));
  }

  const href = typeof window.location.href === 'string' ? window.location.href : '';
  if (!href) {
    return null;
  }

  try {
    return normalizeRequestedCurrency(
      new URL(href, 'https://storefront.shoppex.local').searchParams.get('currency'),
    );
  } catch {
    return null;
  }
}
